import { Link } from 'react-router-dom';
import { useConfig } from '@/api/queries';
import { Icon } from '@/components/ui/Icon';

/** "Your link" in the Dates header: claim or share your personal link. */
export function MyLinkButton() {
  const config = useConfig();
  if (config.data?.features.date_links === false || config.data?.features.date_invites === false) return null;
  return (
    <Link to="/settings/link" className="inline-flex h-9 items-center gap-1.5 rounded-full bg-raised px-3.5 text-sm font-semibold hover:bg-line focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-fg" data-testid="dates-my-link">
      <Icon name="link" size={16} /> Your link
    </Link>
  );
}
